import { OnboardingChecklist } from '@fsp/types';

export interface OnboardingTask {
  id: keyof OnboardingChecklist;
  title: string;
  description: string;

  // Primary stage - navigate to page
  primaryHelperText: string;
  primaryTargetSelector: string;

  // Secondary stage - highlight action button
  secondaryHelperText: string;
  secondaryTargetSelector: string;

  // Detection (use ONE of these)
  chapterType?: string; // For chapter-based tasks: "scope", "hazard", "flow"
  routePattern?: string; // For route-based tasks: "/goods", "/records"
}

export const ONBOARDING_TASKS: OnboardingTask[] = [
  {
    id: 'editFlowDiagram',
    title: 'Edit your flow diagram',
    description: 'Visualize your food production process with a flow diagram.',
    chapterType: 'flow',
    primaryHelperText:
      'Click on the Flow Diagram Editor chapter in the sidebar to view and edit your flow diagram.',
    primaryTargetSelector: '[data-onboarding="chapter-flow"]',
    secondaryHelperText: 'Edit the flow diagram by adding or modifying process steps.',
    secondaryTargetSelector: '[data-onboarding="flow-canvas"]',
  },
  {
    id: 'identifyHazard',
    title: 'Identify first hazard',
    description: 'Add a hazard to track food safety risks in your process.',
    chapterType: 'hazard',
    primaryHelperText:
      'Click on the Process Hazard Analysis chapter in the sidebar to add your first hazard.',
    primaryTargetSelector: '[data-onboarding="chapter-hazard"]',
    secondaryHelperText: 'Click "Create Hazard" to identify your first food safety risk.',
    secondaryTargetSelector: '[data-onboarding="create-hazard-button"]',
  },
  {
    id: 'createPlanScope',
    title: 'Create your scope statement',
    description: 'Use a template to define the scope and boundaries of your food safety plan.',
    chapterType: 'scope',
    primaryHelperText:
      'Click on the Scope chapter in the sidebar and then use a template to define your plan scope.',
    primaryTargetSelector: '[data-onboarding="chapter-scope"]',
    secondaryHelperText: 'Click "Add Template" to create a scope page from a template.',
    secondaryTargetSelector: '[data-onboarding="add-template-button"]',
  },
  {
    id: 'createIncomingGoods',
    title: 'Create an incoming goods form',
    description: 'Set up forms to track incoming goods from suppliers.',
    routePattern: '/goods',
    primaryHelperText:
      'Click "Incoming Goods" in the sidebar to create your first goods tracking form.',
    primaryTargetSelector: '[data-onboarding="nav-incoming-goods"]',
    secondaryHelperText:
      'Click "Add Register" to create your first incoming goods form. You can optionally link these to a process input step and to a company supplier.',
    secondaryTargetSelector: '[data-onboarding="add-goods-button"]',
  },
  {
    id: 'addFirstRecord',
    title: 'Add your first record collection',
    description: 'Start collecting records to demonstrate compliance.',
    routePattern: '/records',
    primaryHelperText:
      'Click "Record Collections" in the sidebar to create your first record collection.',
    primaryTargetSelector: '[data-onboarding="nav-record-collections"]',
    secondaryHelperText: 'Click "Create Collection" to add your first record collection.',
    secondaryTargetSelector: '[data-onboarding="add-record-button"]',
  },
];
